'use strict';

import $ from 'jquery';
import { viewport } from './utilities/viewport';
import { debounce } from './utilities/debounce';

let footerNavToggle = $('.footer-nav button');
let footerExpandedMenuItem = $('.region-footer-top .menu-level-0 > .menu-item--expanded');
let footerExpandedMenuItemLink = footerExpandedMenuItem.find('> a');
let footerSecondMenu = $('.region-footer-top .menu-level-1');
let footerNav = $('.region-footer-top .navigation');

footerNavToggle.on('click', function(){
	$(this).toggleClass('expanded');
	$(this).next().find('.navigation').slideToggle(300);
})

footerExpandedMenuItemLink.on('click', function(e){
	if ( viewport().width <= 760 ){
		e.preventDefault();
		if (!$(this).parent().hasClass('expanded')) {
			closeAllFooterDropdown();
		}
		$(this).parent().add($(this).next()).toggleClass('expanded');
		$(this).next().stop().slideToggle(300);
	}
})

$(window).on('resize', debounce(function(){
	if ( viewport().width > 760 ) {
		if (!footerNavToggle.hasClass('expanded')) {
			footerNavToggle.next().find('.navigation').slideUp(300);
		}
		footerSecondMenu.css('display', 'block');
		footerSecondMenu.add(footerSecondMenu.parent()).removeClass('expanded');
	} else {
		footerNavToggle.removeClass('expanded');
		footerNavToggle.next().find('.navigation').slideDown(300);
		// footerSecondMenu.css('display', 'none');
		if (!footerSecondMenu.hasClass('expanded')) {
			footerSecondMenu.css('display', 'none');
		}
	}
}, 250));

function closeAllFooterDropdown(){
	footerExpandedMenuItem.add(footerExpandedMenuItem.find('> ul')).removeClass('expanded');
	footerExpandedMenuItem.find('> ul').stop().slideUp(300);
}
